module.exports = __webpack_public_path__ + "img/ico-grade-purple.6c01c541.svg";